import {RouterProvider} from 'react-router-dom';
import React from "react";
import {ConfigProvider} from "antd";
import {FFPopupClose} from "ui/FFPopupClose";
import {appRouter} from "Application/router";
import {ContextComponent} from "hooks/ContextComponent";
import {isWidgetRoute} from "utils";
import {captureAdminScript, endAdminRun} from "adminLink";

// Admin utilities are only needed for non-widget routes
if (!isWidgetRoute()) {
    // Synchronous: the runner below is a lazily-loaded chunk that arrives after the
    // first navigations, by which time an admin link's ?admin= may already be gone —
    // the bare-route language redirect (router.tsx's BareRouteRedirect) navigates to
    // a location react-router snapshotted before this ran. Capture it here; the
    // runner only replays what this call took.
    captureAdminScript();
    // If the chunk never arrives (a stale index.html after a deploy, a flaky network)
    // nothing would ever call endAdminRun, and captureAdminScript may already have
    // raised the overlay — so release it here rather than wait out MAX_HOLD_MS.
    import("adminUtil").catch((e) => {
        console.error("[admin-link] could not load the admin utilities chunk:", e);
        endAdminRun();
    });
}

// antd writes its own font stack onto every component it renders (a modal's title and text
// included), over the body's — without this token they come out in the system font.
const THEME = {
    token: {
        fontFamily: "Satoshi, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', "
            + "'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    },
};

export const Application = () => {
    return <ConfigProvider theme={THEME} modal={{closeIcon: <FFPopupClose/>}}>
        <ContextComponent>
            <RouterProvider router={appRouter}/>
        </ContextComponent>
    </ConfigProvider>
}
